/** `/c/$companyId/purchases/payments/$paymentId?tab&action` — a supplier payment, in every state. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PAYMENT_PAGE_TABS } from "../api/codes";
import { CODE_SETS } from "../ledger/books";
import { PaymentPage } from "../payments/page/PaymentPage";
import { CodeGate } from "../shell/CodeGate";

const search = z.object({
  tab: z.enum(PAYMENT_PAGE_TABS).optional().catch(undefined),
  /** From the review queue: open the dialog that records the GST paid on imported services. */
  action: z.enum(["settle"]).optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/c/$companyId/purchases/payments/$paymentId")({
  validateSearch: (raw) => search.parse(raw),
  component: PaymentRoute,
});

function PaymentRoute(): JSX.Element {
  const { companyId, paymentId } = Route.useParams();
  const { tab, action } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CodeGate companyId={companyId} codes={CODE_SETS.PR}>
      <PaymentPage
        companyId={companyId}
        paymentId={paymentId}
        tab={tab}
        settleTax={action === "settle"}
        // Once opened, the address drops it: a reload doesn't open the dialog again.
        onSettleOpened={() => void navigate({ search: { tab }, replace: true })}
      />
    </CodeGate>
  );
}
